<div class="row h-100">
  <div class="left-flexbase-box h-100">
    <div class="card overflow-hidden shadow-sm rounded-4 border h-100">
      <div class="card-body d-flex flex-column h-100">
        <!-- Header -->
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h2 class="fw-500 mb-0 fs-24">Available Products</h2>
        </div>

        <!-- Search -->
        <div class="position-relative mb-3">
          <svg-icon
            [name]="'search-topbar'"
            class="position-absolute top-50 translate-middle-y ms-3 svg-24 svg-primary"
          ></svg-icon>
          <input
            class="form-control form-control-lg ps-5 rounded-5"
            type="text"
            placeholder="Search product code or description"
            [(ngModel)]="search"
          />
        </div>

        <!-- Product List -->
        <div class="bg-light mx-n3 d-flex flex-column flex-fill gap-3 overflow-y-auto p-3 mb-n3">
          <!-- Product Card -->
          @for (product of productList(); track product.id) {
            <lib-product-preview-card
              [product]="product"
              [showCheckbox]="false"
              (productSelected)="submitLinkedProducts($event)"
              (click)="$event.stopPropagation()"
            >
            </lib-product-preview-card>
          }
          @if (productList().length === 0) {
            <div class="d-flex flex-column align-items-center justify-content-center gap-2 h-100">
              <i class="bi bi-bag fs-48 text-gray-300"></i>
              <p class="mb-0 fs-20 text-gray-300">No products found.</p>
            </div>
          }
        </div>
        <!-- <div class="d-flex justify-content-around p-3 mx-n3 mb-n3">
          <button class="btn btn-primary btn-h45 d-flex align-items-center gap-2" >
            <i class="bi bi-plus-lg"></i> Add Selected @if (selectedProducts().length) { ({{ selectedProducts().length }}) }
          </button>
        </div> -->
      </div>
    </div>
  </div>
  <div class="col h-100">
    <div class="rounded-4 bg-white border p-3 attribute-card d-flex flex-column gap-2 h-100">
      <h2 class="mb-2">Linked Products</h2>

      <div class="flex-fill h-100 overflow-hidden">
        <div class="table-outer table-theme">
          <div class="table-responsive h-100">
            <p-table [value]="linkedProductList()">
              <ng-template #header>
                <tr>
                  <th sortableColumn="linkedProduct.code" pSortableColumn="linkedProduct.code">
                    Product Code <p-sortIcon field="linkedProduct.code"></p-sortIcon>
                  </th>
                  <th>Description</th>
                  <th>Category / Subcategory</th>
                  <th width="150px"></th>
                </tr>
              </ng-template>
              <ng-template #body let-product>
                <tr>
                  <td pSortableColumn="linkedProduct.code">{{ product.linkedProduct.code }}</td>
                  <td>{{ product.linkedProduct.description }}</td>
                  <!-- <td>{{ product.linkedProduct.subcategory?.category?.code }}</td>
                  <td>{{ product.linkedProduct.subcategory?.code }}</td> -->
                  <td>
                    {{ product.linkedProduct.subcategory?.category?.code }}
                    @if (product.linkedProduct.subcategory?.code) {
                      / {{ product.linkedProduct.subcategory?.code }}
                    }
                  </td>
                  <td>
                    <a href="javascript:void(0)" (click)="deleteLinkedProduct(product.id)">
                      <i class="bi bi-link-45deg lh-1 me-2"></i>Unlink</a
                    >
                    <!-- <div ngbDropdown container="body">
                      <svg-icon [name]="'menu-dots'" class="svg-24" ngbDropdownToggle></svg-icon>
                      <div ngbDropdownMenu>
                        <button class="dropdown-item" (click)="deleteLinkedProduct(product.id)">Unlink</button>
                      </div>
                    </div> -->
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td colspan="10" class="text-center">No linked products found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
